import React, { Component } from 'react'
import {
    formHandler,
    Boolean,
    Button,
    RadioInput,
    TextInput,
    Select,
} from '../../ui'

import {
    computerMakeOptions,
    computerTypeOptions,
    ramOptions,
} from '../../utils'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gearActions from '../../../actions/gear'

class ComputerSelectionForm extends Component {
    constructor(props) {
        super(props)

        this.state = { data: this.props.data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    _submitComputerData = () => {
        const data = {
            computer_type: this.state.data.computer_type,
            make: this.state.data.make,
            model: this.state.data.model,
            year: this.state.data.year,
            ram: this.state.data.ram,
            gpu: this.state.data.gpu,
            processor_type: this.state.data.processor_type,
            processor_speed: this.state.data.processor_speed,
            usb3: this.state.data.usb3,
            thunderbolt: this.state.data.thunderbolt,
            additional_details: this.state.data.additional_details,
        }

        this.props.gearActions.submitComputer(
            data,
            this.props.crew_uuid,
            this.state.data.uuid
        )
    }

    render() {
        const errors = this.props.gear.errors

        return (
            <div>
                <RadioInput
                    error={ errors.computer_type }
                    label="Computer Type"
                    name="computer_type"
                    options={ computerTypeOptions() }
                    updateValue={ this._updateValue }
                    value={ this.state.data.computer_type }
                />
                <RadioInput
                    error={ errors.make }
                    label="Make"
                    name="make"
                    options={ computerMakeOptions() }
                    updateValue={ this._updateValue }
                    value={ this.state.data.make }
                />
                <TextInput
                    error={ errors.model }
                    name="model"
                    placeholder="Model"
                    updateValue={ this._updateValue }
                    value={ this.state.data.model }
                />
                <TextInput
                    error={ errors.year }
                    name="year"
                    placeholder="Year"
                    type="number"
                    updateValue={ this._updateValue }
                    value={ this.state.data.year }
                />
                <Select
                    error={ errors.ram }
                    name="ram"
                    options={ ramOptions() }
                    placeholder="RAM"
                    updateValue={ this._updateValue }
                    value={ this.state.data.ram }
                />
                <TextInput
                    error={ errors.gpu }
                    name="gpu"
                    placeholder="GPU"
                    updateValue={ this._updateValue }
                    value={ this.state.data.gpu }
                />
                <TextInput
                    error={ errors.processor_type }
                    name="processor_type"
                    placeholder="Processor Type"
                    updateValue={ this._updateValue }
                    value={ this.state.data.processor_type }
                />
                <TextInput
                    error={ errors.processor_speed }
                    name="processor_speed"
                    placeholder="Processor Speed"
                    updateValue={ this._updateValue }
                    value={ this.state.data.processor_speed }
                />
                <Boolean
                    error={ errors.usb3 }
                    label="USB 3?"
                    name="usb3"
                    updateValue={ this._updateValue }
                    value={ this.state.data.usb3 }
                />
                <Boolean
                    error={ errors.thunderbolt }
                    label="Thunderbolt?"
                    name="thunderbolt"
                    updateValue={ this._updateValue }
                    value={ this.state.data.thunderbolt }
                />
                <TextInput
                    error={ errors.additional_details }
                    name="additional_details"
                    placeholder="Additional Details"
                    type="textarea"
                    updateValue={ this._updateValue }
                    value={ this.state.data.additional_details }
                />

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitComputerData }
                    status="primary"
                >
                    Save
                </Button>
            </div>
        )
    }
}

ComputerSelectionForm.propTypes = {
    appState: React.PropTypes.object,
    crew_uuid: React.PropTypes.string,
    data: React.PropTypes.object,
    gear: React.PropTypes.object,
    gearActions: React.PropTypes.object,
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            gear: state.gear,
        }
    },
    (dispatch) => {
        return {
            gearActions: bindActionCreators(gearActions, dispatch),
        }
    }
)(ComputerSelectionForm)



// WEBPACK FOOTER //
// ./app/components/gear/modals/computer_selection_form.js